import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';
import './ConnectedQuizProfessor.css';
import Header from '../Header/Header';
import Spinner from '../Spinner/Spinner';
import loadingIcon from '../Spinner/loadingIcon.gif';
import { handleException } from '../../app/util/util';
import loaderColors1 from '../Spinner/loaderColors1.gif';
import CQProfessorAssignment from './CQProfessorAssignment/CQProfessorAssignment';
import { withAuth, handleResponse, handleJwtTokenForKeppMeLoggedIn } from "../../app/util/HOC";
export function ConnectedQuizProfessor() {
    const isTAUser = localStorage.getItem("cqassistantFlag");
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const keepMeLogIn = localStorage.getItem('keepLoggedIn') ? "true" : "false";
    const authToken = userVO.apJwtAuthenticationToken ? userVO.apJwtAuthenticationToken : localStorage.getItem('apJwtAuthenticationToken');
    const [semList, setSemList] = useState([]);
    const [classList, setClassList] = useState([]);
    const [isReportDowl, setIsReportDowl] = useState(false);
    const [isProfQuizLoading, setIsProfQuizLoading] = useState(false);
    const [isProfQuizzesLoading, setIsProfQuizzesLoading] = useState(true);
    const [showAssignmentQuestions, setShowAssignmentQuestions] = useState(false);
    var defaultSemId = Array.from(new Set(classList.map(x => { return (x.semesterId)}))).join('').trim(), sem_id = '';
    const [cqProfAssignmentProps, setCqProfAssignmentProps] = useState({
        cqUserId: '', cqSemId: '', cqSemED: '', cqSemSD: '', cqClassId: '', cqClassCode: '',
        cqClassName: '', cqQuizSetId: '', cqQuizId: '', cqQuizVer: '', cqIdentifier: '',
        cqQuizName: '', cqQuizStatus: '', cqQuizAssigned: '', cqQuizReleaseOpt: '',
        cqQuizResultFlag: '', cqQuizSD: '', cqQuizED: '', cqQuizRD: '', cqQuizCD: ''
    });
    const getSessionVO = () => {
        return {
            "appType": "web",
            "deviceMacId": "",
            "keepMeLoggedInFlag": keepMeLogIn,
            "deviceOS": localStorage.getItem('deviceOS'),
            "deviceType": localStorage.getItem('deviceType'),
            "browserName": localStorage.getItem('browserName'),
            "sessionAuthenticationToken": userVO.sessionAuthenticationToken
        }
    }
    function fetchData() {
        var reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "schoolId": userVO.schoolId,
                "userRoleId": userVO.userRoleId,
                "userActivityVO": {
                    "lastReadBookId": "",
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "lastReadParagraphId": "",
                    "lastViewedOutlineId": "",
                    "lastReadSubSectionId": "",
                    "schoolId": userVO.schoolId,
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                },
                "sessionVO": getSessionVO()
            },
            "cqSemesterVO": { "schoolId": userVO.schoolId }
        };
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        };
        fetch(`${localStorage.getItem('ENV')}/manageCQ/getActiveSemesterForProfessor`, requestOptions)
            .then(response => response.json())
            .then(data => {
                if (data.status === "true") {
                    if (data.cqSemesterVOList) {
                        var cqSemesterVOList = Array.isArray(data.cqSemesterVOList) ? data.cqSemesterVOList : [data.cqSemesterVOList];
                        setSemList(cqSemesterVOList);
                    }
                    sem_id = semList.map(x => { return x.semesterId });
                } else if (data.wkErrorCode) {
                    handleException(data);
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    function fetchData1(semId) {
        setShowAssignmentQuestions(false);
        var reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "schoolId": userVO.schoolId,
                "userRoleId": userVO.userRoleId,
                "keepMeLoggedInFlag": keepMeLogIn,
                "userActivityVO": {
                    "lastReadBookId": "",
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "lastReadParagraphId": "",
                    "lastViewedOutlineId": "",
                    "lastReadSubSectionId": "",
                    "schoolId": userVO.schoolId,
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                },
                "sessionVO": getSessionVO()
            }
        };
        if (semId) {
            reqData.cqSemesterVO = { "semesterId": semId };
            reqData.userVO.userActivityVO.lastViewedCQSemesterId = semId;
        }
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
        };
        fetch(`${localStorage.getItem('qpAPI')}/manageProfessor/getCQClassBySemesterId`, requestOptions)
            .then(handleResponse)
            .then(response => response.json())
            .then(handleJwtTokenForKeppMeLoggedIn)
            .then(data => {
                if (data) {
                    if (data.cqClassVOList) {
                        data.cqClassVOList.map(cqClass => {
                            if (cqClass.cqClassAssistantVOList) {
                                cqClass.cqClassAssistantVOList.sort((user1, user2) => (user1.ccUserRole).localeCompare(user2.ccUserRole));
                            }
                        });
                        setClassList(data.cqClassVOList);
                    }
                    setIsProfQuizzesLoading(false);
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    function cqClassCumulativeReport(cqClassName, cqClassId, semesterId) {
        setIsReportDowl(true);
        var downQuizList = classList.filter(cqClass => (cqClass.classId === cqClassId))[0].classQuizVOList, quizCount = 0;
        downQuizList.map(downQuiz => {
            if (downQuiz.scheduleStatus !== "scheduled" && downQuiz.scheduleStatus !== "yet to schedule") {
                quizCount += 1;
            }
        });
        if (quizCount === 0) {
            alert("None of your quizzes contain student results. Please assign your quizzes and try again after students have submitted.");
            setIsReportDowl(false);
        } else {
            var reqData = {
                "userVO": {
                    "userId": userVO.userId,
                    "userRole": userVO.userRole,
                    "schoolId": userVO.schoolId,
                    "userRoleId": userVO.userRoleId,
                    "keepMeLoggedInFlag": keepMeLogIn,
                    "userActivityVO": {
                        "lastReadBookId": "",
                        "lastReadPageNum": "",
                        "lastReadChapterId": "",
                        "lastReadSectionId": "",
                        "lastReadParagraphId": "",
                        "lastViewedOutlineId": "",
                        "lastReadSubSectionId": "",
                        "lastActivityCode": "BOOKSHELF",
                        "pageNavigatingFrom": "EReader",
                        "pageNavigatingTo": "Bookshelf",
                    },
                    "sessionVO": getSessionVO()
                },
                "classV": {
                    "name": cqClassName,
                    "classId": cqClassId,
                    "semesterId": semesterId,
                    "currentDate": new Date().toLocaleString('en-US', { hour12: false }).replace(',', '')
                }
            };
            const requestOptions = {
                method: 'POST',
                body: JSON.stringify(reqData),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                },
            };
            fetch(`${localStorage.getItem('qpAPI')}/quiz/api/getCumulativeReport`, requestOptions)
                .then(handleResponse)
                .then(response => response.blob())
                .then(handleJwtTokenForKeppMeLoggedIn)
                .then(blob => {
                    setIsReportDowl(false);
                    if (blob.type === "application/octet-stream") {
                        const url = window.URL.createObjectURL(new Blob([blob]));
                        const link = document.createElement('a'); link.href = url;
                        link.setAttribute('download', `${userVO.lastName}_${cqClassName}.xlsx`);
                        document.body.appendChild(link);
                        link.click(); link.parentNode.removeChild(link);
                    } else {
                        alert("Exception Occurs. Please try again later");
                    }
                }).catch(error => {
                    console.error("There has been a problem with your fetch operation:", error);
                });
        }
    }
    useEffect(() => {
        if (isTAUser == "true") {
            document.title = "Classes Assisting - Connected Quizzing | Casebook Connect | Aspen Publishing";
        } else {
            document.title = "Connected Quizzing | Casebook Connect | Aspen Publishing";
        }
        fetchData();
        fetchData1(sem_id[0]);
    }, []);
    const handlebackApiRender = () => {
        fetchData();
        fetchData1(sem_id[0]);
        setShowAssignmentQuestions(true);
    }
    function dateTimeModification(valchk) {
        var estTime = moment.tz(valchk, "America/New_York")
        var t = estTime.clone().tz(moment.tz.guess());
        var locTimeZon = estTime.clone().tz(moment.tz.guess()).format('z');
        var splittingTim = t.format().split("T");
        var timeCHk = splittingTim[1].split(":");
        t = dateModification(splittingTim[0]);
        if (timeCHk != undefined && timeCHk != null) {
            var meridian, hr, min;
            if (timeCHk[0] > 12) {
                meridian = "PM";
                hr = timeCHk[0] - 12;
                min = timeCHk[1];
            } else if (timeCHk[0] == "12") {
                meridian = "PM";
                hr = "12";
                min = timeCHk[1];
            } else {
                meridian = "AM";
                min = timeCHk[1];
                if (timeCHk[0] == "00") {
                    hr = "12";
                } else {
                    hr = timeCHk[0];
                }
            }
            hr = Number(hr); min = Number(min);
            t = '' + t + ' at ' + (hr < 10 ? `0${hr}` : `${hr}`) + ':'
                + (min < 10 ? `0${min}` : `${min}`) + ' ' + meridian + ' ' + locTimeZon;
        } else {
            t = '' + t + ' ';
        }
        return t;
    }
    function dateModification(archiveDate) {
        archiveDate = archiveDate.split(" ");
        var splitting = archiveDate[0].split("-");
        switch (splitting[1]) {
            case "01":
                splitting[1] = "January";
                break;
            case "02":
                splitting[1] = "February";
                break;
            case "03":
                splitting[1] = "March";
                break;
            case "04":
                splitting[1] = "April";
                break;
            case "05":
                splitting[1] = "May";
                break;
            case "06":
                splitting[1] = "June";
                break;
            case "07":
                splitting[1] = "July";
                break;
            case "08":
                splitting[1] = "August";
                break;
            case "09":
                splitting[1] = "September";
                break;
            case "10":
                splitting[1] = "October";
                break;
            case "11":
                splitting[1] = "November";
                break;
            case "12":
                splitting[1] = "December";
        }
        return splitting[1] + " " + splitting[2] + ", " + splitting[0];
    }
    const foucsOncopyClassCode = (event) => {
        event.preventDefault();
        var buttons = document.getElementsByClassName("cqProfCodeCopyBtn");
        if (buttons.length !== undefined && buttons.length > 0) {
            buttons[0].focus();
        } else if (buttons) {
            document.getElementsByClassName("cqProfCodeCopyBtn").focus();
        }
    }
    return (
        <>
            <Spinner
                loading={isProfQuizzesLoading}
                imageSrc={loaderColors1}
                overlayBackground="rgba(0,0,0,0.5)"
            />
            <div className={isReportDowl === true ? "cqProfLoadingSpinner" : "cqProfSpinner"}>
                <Spinner
                    loading={isReportDowl}
                    imageSrc={loadingIcon}
                    imageStyle={{ marginTop: "20%", width: "50px" }}
                    overlayBackground="rgba(0,0,0,0.5)"
                />
            </div>
            <button onClick={foucsOncopyClassCode} className="skip-to-main">Skip to the main</button>
            <Header userVO={userVO} pageName="CQProf"></Header>
            {
                isTAUser == "true" && showAssignmentQuestions &&
                <div>
                    <div className="cqProfNotifiContainer">
                        <div style={{ textAlign: "center" }} className="display-inline-block cqProfNotifiTxt col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            Connected Quizzing content is for personal use only. Redistribution is strictly prohibited. &copy; Aspen Publishing
                        </div>
                    </div>
                </div>
            }
            <Spinner
                loading={isProfQuizLoading}
                imageSrc={loaderColors1}
                overlayBackground="rgba(0,0,0,0.5)"
            />
            {
                isProfQuizzesLoading === false &&
                <main>
                    <div className='container'>
                        <div className="card cqProfContainerSection">
                            <div className="card-body cqProfContainerCard">
                                <div className="row" >
                                    <div className="col-xl-7 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <div className="cqProfLogoContainer col-xl-7 col-lg-8 col-md-10 col-sm-12 col-xs-12">
                                            <img className="cqProfLogo" src="/cc/images/CQ_logo_grey_screen.png" alt="Connected Quizzing" role='heading' aria-level='1'></img>
                                        </div>
                                    </div>
                                    <div className='col-xl-5 col-lg-6 col-md-6 col-sm-12 col-xs-12 mt-2'>
                                        <div className="cqProfViewContainer row">
                                            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 cqProfViewingLabel text-sm-left text-md-right text-lg-right text-xl-right text-left pl-3" >
                                                <label htmlFor="selectedSemester">Viewing:</label>
                                            </div>
                                            <div className="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9" style={{ paddingRight: '9px' }} >
                                                <select data-testid="select_semester" id="selectedSemester" aria-label='Selected Semester' className="cqProfViewingInput form-control text-box-common" value={defaultSemId}
                                                    onChange={e => fetchData1(e.target.value)}>
                                                    {
                                                        semList.map(sem => {
                                                            if (sem.semesterId === defaultSemId) {
                                                                localStorage.setItem('profSemED', sem.semesterEndDate)
                                                                localStorage.setItem('profSemSD', sem.semesterStartDate)
                                                            }
                                                            return (
                                                                <option key={sem.semesterId} value={sem.semesterId}>{sem.semesterName}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    showAssignmentQuestions ?
                                        <CQProfessorAssignment displayAssignment={() => setShowAssignmentQuestions(false)}
                                            data={cqProfAssignmentProps} assignmentLoading={() => setIsProfQuizLoading(false)}
                                            handlebackApiRender={handlebackApiRender} />
                                        :
                                        classList.map((profClass, index) => (
                                            <>
                                                <div key={'classDiv' + index} className='mt-3 mb-2'>
                                                    <div key={'className' + index} className='cqProfClassName' role="heading" aria-level="2">{profClass.className}</div>
                                                    {
                                                        profClass.cqClassAssistantVOList ?
                                                            <div className='cqProfAsstNames'>Teaching with
                                                                {
                                                                    profClass.cqClassAssistantVOList.map((cqClassStud, index) => {
                                                                        return (
                                                                            <span key={'cqClassStud' + index}>
                                                                                {cqClassStud.ccUserRole === 'Student' ? ` Assistant ` : ` Professor `}
                                                                                {cqClassStud.firstName + " " + cqClassStud.lastName}
                                                                                {index !== (profClass.cqClassAssistantVOList.length - 1) && ', '}
                                                                            </span>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                            : null
                                                    }
                                                    {
                                                        profClass.classType === 'anonymous' ?
                                                            <div className='cqProfAsstNames mt-2'>
                                                                Students' results are anonymous
                                                            </div>
                                                            : null
                                                    }
                                                    <div className='row my-1'>
                                                        <div className='col-xl-6 col-lg-5 col-md-4 col-sm-12 col-12'>
                                                            <div className="cqProfQuizzLabel" role="heading" aria-level="3">Quizzes:</div>
                                                        </div>
                                                        <div className='col-xl-6 col-lg-7 col-md-8 col-sm-12 col-12 pr-xl-0 pr-lg-2 pr-md-3 pr-0 pl-0'>
                                                            <div className='row ml-xl-1 ml-lg-5 ml-md-0 ml-0'>
                                                                <div className='col-xl-5 col-lg-4 col-md-4 col-sm-4 col-4 text-xl-right text-lg-right text-md-right text-left'>
                                                                    <label htmlFor="cqProfClassCode" className="cqProfClassCode pr-0">Class Code </label>
                                                                </div>
                                                                <div className='col-xl-7 col-lg-8 col-md-7 col-sm-8 col-8 pl-xl-0 pl-lg-2 pl-md-0 pl-0'>
                                                                    <div className='d-inline-flex'>
                                                                        <input id="cqProfClassCode" type="text" className="cqProfCodeInput rounded-0" aria-label="Class Code" value={profClass.classCode}></input>
                                                                        <button className="cqProfCodeCopyBtn" aria-label={`Copy ${profClass.className} class code`} onClick={() => { navigator.clipboard.writeText(profClass.classCode) }}>Copy</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='row pb-3 ml-0'>
                                                        <ul className='m-0 p-0' style={{listStyleType: "none", width:"100%"}}> 
                                                            {
                                                                profClass.classQuizVOList && profClass.classQuizVOList.map((quiz, index) => (
                                                                    <>
                                                                        <li key={'classQuizBtn' + index} className='cqProfClassDiv col-xl-2 col-lg-3 col-md-3 col-sm-5 col-5 float-left'>
                                                                            <div className='cqProfClassGrayBtnDiv'>
                                                                                <button className='btn cqProfClassQuizBtn' type='button'
                                                                                    onClick={() => [setCqProfAssignmentProps({
                                                                                        cqUserId: profClass.professorUserId, cqSemId: profClass.semesterId, cqSemED: localStorage.getItem('profSemED'),
                                                                                        cqSemSD: localStorage.getItem('profSemSD'), cqClassId: profClass.classId, cqClassCode: profClass.classCode,
                                                                                        cqClassName: profClass.className, cqQuizSetId: profClass.quizSetId, cqQuizId: quiz.id, cqQuizVer: quiz.version,
                                                                                        cqIdentifier: quiz.identifier, cqQuizName: quiz.name, cqQuizStatus: quiz.scheduleStatus,
                                                                                        cqQuizAssigned: quiz.assigned, cqQuizReleaseOpt: quiz.releaseOption, cqQuizResultFlag: quiz.publishResultInstantlyFlag,
                                                                                        cqQuizSD: dateTimeModification(quiz.quizStartDate), cqQuizED: dateTimeModification(quiz.quizEndDate),
                                                                                        cqQuizRD: dateTimeModification(quiz.releaseDate), cqQuizCD: dateTimeModification(quiz.closeDate)
                                                                                    }), setShowAssignmentQuestions(true), setIsProfQuizLoading(true)]}
                                                                                    style={
                                                                                        quiz.scheduleStatus === 'yet to schedule' ?
                                                                                            { background: '#007AC3' } :
                                                                                            quiz.scheduleStatus === 'scheduled' ?
                                                                                                { background: "#A6D1EB", color: "#474747" } :
                                                                                                quiz.scheduleStatus === 'active' ?
                                                                                                    { background: "#A6D1EB", color: "#474747" } :
                                                                                                    quiz.scheduleStatus === 'completed' ?
                                                                                                        { background: '#DADADA', color: '#474747' } : ''
                                                                                    }>
                                                                                    {quiz.name}
                                                                                </button>
                                                                            </div>
                                                                            <div className='cqProfClassQuizDue pt-1'>
                                                                                {
                                                                                    quiz.scheduleStatus === 'yet to schedule' ? '' :
                                                                                        quiz.scheduleStatus === 'scheduled' ?
                                                                                            (`Starts on: ` + dateTimeModification(quiz.quizStartDate)) :
                                                                                            (quiz.scheduleStatus === 'active' && quiz.assigned === true) ?
                                                                                                (`Ends on: ` + dateTimeModification(quiz.quizEndDate)) :
                                                                                                quiz.scheduleStatus === 'completed' ?
                                                                                                    'Completed' : ''
                                                                                }
                                                                            </div>
                                                                        </li>
                                                                    </>
                                                                ))
                                                            }
                                                        </ul>
                                                    </div>
                                                    {
                                                        profClass.classQuizVOList ?
                                                            (
                                                                <div className='mb-4'>
                                                                    <button className="btn cqProfCumuBtn"
                                                                        onClick={() => cqClassCumulativeReport(
                                                                            profClass.className, profClass.classId, profClass.semesterId)}>
                                                                        Download Cumulative Report
                                                                    </button>
                                                                </div>
                                                            )
                                                            : null
                                                    }
                                                </div>
                                                <div className='cqProfQuizBorder'></div>
                                            </>
                                        ))
                                }
                            </div>
                        </div>
                    </div>
                </main>
            }
        </>
    )
}
export default withAuth(ConnectedQuizProfessor);